export default __webpack_public_path__ + "static/ISO_17100-5a6723c667a8d89741621b30c58328ea.svg";